import React from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import DocsLayout, { RedirectToFirstPage } from './pages/DocsLayout';
import DocPage from './pages/DocPage';
import { AdminProvider } from './admin/AdminContext';
import AdminLayout from './admin/AdminLayout';
import AdminHome from './admin/AdminHome';
import Editor from './admin/Editor';
import Login from './admin/Login';

/*
 * Public docs:  /:product/:version/:slug   (content from /api/v1/docs, published pages only)
 * Docs CMS:     /admin                     (admin-only editor backed by /api/v1/docs/admin)
 */
export default function App() {
  return (
    <Routes>
      <Route path="/admin" element={<AdminProvider><Outlet /></AdminProvider>}>
        <Route path="login" element={<Login />} />
        <Route element={<AdminLayout />}>
          <Route index element={<AdminHome />} />
          <Route path="pages/:pageId" element={<Editor />} />
        </Route>
      </Route>
      <Route path="/" element={<RedirectToFirstPage />} />
      <Route path="/:product" element={<RedirectToFirstPage />} />
      <Route path="/:product/:version" element={<DocsLayout />}>
        <Route index element={<RedirectToFirstPage />} />
        <Route path=":slug" element={<DocPage />} />
      </Route>
    </Routes>
  );
}
